/**
 * Automatisches Scrollen zu Query-Blöcken nach Pagination-Navigation
 */
export function setupQueryPaginationScroll() {
  // Prüfe, ob die URL einen query-page Parameter enthält
  const urlParams = new URLSearchParams(window.location.search);
  let hasQueryPageParam = false;
  
  // Suche nach query-{id}-page Parametern
  for (const [key] of urlParams) {
    if (key.match(/^query-\d+-page$/)) {
      hasQueryPageParam = true;
      break;
    }
  }
  
  if (!hasQueryPageParam) {
    return;
  }
  
  // Warte kurz, bis die Seite vollständig geladen ist
  setTimeout(() => {
    // Finde alle Query-Blöcke mit Pagination
    const queryBlocks = document.querySelectorAll('.wp-block-query');
    
    queryBlocks.forEach((block) => {
      const pagination = block.querySelector('.wp-block-query-pagination');
      
      if (pagination) {
        // Smooth scroll zum Query-Block
        const offset = 100; // Offset für Fixed Header
        const blockPosition = block.getBoundingClientRect().top + window.pageYOffset - offset;
        
        window.scrollTo({
          top: blockPosition,
          behavior: 'smooth'
        });
      }
    });
  }, 100);
}

/**
 * Event Listener für Pagination Links
 * Fügt smooth scrolling hinzu, wenn auf Pagination-Links geklickt wird
 */
export function setupQueryPaginationClickScroll() {
  document.addEventListener('click', (e) => {
    const paginationLink = e.target.closest('.wp-block-query-pagination a');
    
    if (paginationLink) {
      // Speichere die Position des Query-Blocks
      const queryBlock = paginationLink.closest('.wp-block-query');
      
      if (queryBlock) {
        // Speichere die ID im sessionStorage
        const queryId = queryBlock.querySelector('.wp-block-query-pagination')?.getAttribute('aria-label') || 'query-block';
        sessionStorage.setItem('scrollToQuery', queryId);
      }
    }
  });
}
